/*
 * Copyright (c) Sureify Labs 2020.
 * This source code is licensed under MIT License.
 * @author jayendrasharan <jayendra@sureify.com>
 * Created at: 03/05/20, 4:57 AM
 * Last Modified at: 03/05/20, 2:09 AM
 */

import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Button } from '../Button'
import ProductCard from './ProductCard'
import {
  CardBody,
  FaCardIcon,
  CardTitle,
  CardWrapper,
  CCBody,
  CCContentWrapper,
  CCHeader,
  CCInput,
  CCWrapper,
  FakeInput,
  Heading,
  Icon,
  IconCardWrapper,
  IconLabelText,
  Input,
  Label,
  LabelText,
  Metric,
  Value,
  CardArrow,
  CBWrapper,
  CBTitle,
  CBSubTitle,
  CBLabel,
  CBButtonWrapper,
  CBDescription,
  CBActiveArrowWrapper,
  CBActiveArrow,
  Prefix,
  Val,
  ContentWrapper,
  CardWithHeader,
  CardHeading
} from './styles'

const isImg = (label) => {
  return label.indexOf('http') === 0
}

const getRadioComponent = (props, hcEnabled) => {
  const {
    shape,
    labelText,
    id,
    icon,
    name,
    inputRef,
    onChange,
    checked,
    content,
    hasBorderTop,
    disabled,
    description,
    onActionBtnClick,
    cardButton,
    cardButtonTheme,
    productDetails,
    docWidth,
    hideCardButtonArrow,
  } = props
  let cardValue = ''
  if (hasBorderTop) {
    cardValue = (
      <ContentWrapper>
        <Prefix>{content.prefix || ''}</Prefix>
        <Val>{content.value}</Val>
        <Metric> {content.metric} </Metric>
      </ContentWrapper>
    )
  }

  switch (shape) {
    case 'htmlRadioButton':
      return (
        <Fragment>
          <Input
            id={id}
            ref={inputRef}
            type='radio'
            name={name}
            onChange={onChange}
            defaultChecked={checked}
            disabled={disabled}
            hcEnabled={hcEnabled}
          />
          <>
            <LabelText for={id} name='label-text' shape={shape}>
              <div dangerouslySetInnerHTML={{ __html: labelText }} />
            </LabelText>
          </>
        </Fragment>
      )
    case 'card_columns':
      return (
        <Fragment>
          <CCInput
            id={id}
            ref={inputRef}
            type='radio'
            name={name}
            onChange={onChange}
            defaultChecked={checked}
            disabled={disabled}
          />
          <span className='radio_button' />
          <CCWrapper className='wrapper'>
            <CCContentWrapper name='cc-content-wrapper'>
              <CCHeader name='cc-header'>{labelText}</CCHeader>
              <CCBody name='cc-body'>{(content && content.line1) || ''}</CCBody>
              <CCBody name='cc-body'>{(content && content.line2) || ''}</CCBody>
            </CCContentWrapper>
          </CCWrapper>
        </Fragment>
      )
    case 'card':
      return (
        <Fragment>
          <Input
            id={id}
            ref={inputRef}
            type='radio'
            name={name}
            onChange={onChange}
            defaultChecked={checked}
            disabled={disabled}
          />
          <CardWrapper name='card-wrapper'>
            <CardTitle name='card-title'>
              {hasBorderTop ? (
                <>
                  <Value name='value'>{cardValue}</Value>
                  <Metric name='heading'>{content.heading}</Metric>
                  <Metric name='metric'>{labelText}</Metric>
                </>
              ) : (
                labelText
              )}
            </CardTitle>
            <CardArrow />
            <CardBody name='card-body'>
              <Heading name='heading'>
                {hasBorderTop ? content.plan_desc : content.heading}
              </Heading>
              <Value name='value'>
                {hasBorderTop
                  ? cardValue
                  : `${content.prefix || ''}${content.value}`}
              </Value>
              <Metric name='metric'>{!hasBorderTop && content.metric}</Metric>
            </CardBody>
          </CardWrapper>
        </Fragment>
      )
    case 'icon_card':
      return (
        <Fragment>
          <Input
            id={id}
            ref={inputRef}
            type='radio'
            name={name}
            onChange={onChange}
            defaultChecked={checked}
            disabled={disabled}
          />
          <IconCardWrapper checked={checked}>
            <FaCardIcon name='fa-icon' checked={checked} aria-hidden='true'>
              <i className={'fas ' + icon} />
            </FaCardIcon>
            <IconLabelText checked={checked}>{labelText}</IconLabelText>
          </IconCardWrapper>
        </Fragment>
      )
    case 'card_button':
      return (
        <Fragment>
          <Input
            id={id}
            ref={inputRef}
            type='radio'
            name={name}
            onChange={onChange}
            defaultChecked={checked}
          />
          <CBWrapper name='card-btn-wrapper' className='cb_wrapper'>
            <CBTitle className='cb_title'>
              {content.prefix}
              {content.value}
            </CBTitle>
            <CBSubTitle className='cb_subtitle'>{content.metric}</CBSubTitle>
            <CBLabel className='cb_label'>{labelText}</CBLabel>
            {cardButton && cardButton.label && (
              <CBButtonWrapper className='cb_button'>
                <Button
                  label={cardButton.label}
                  alignment='center'
                  themeConfiguration={cardButtonTheme}
                  handleButtonClick={onActionBtnClick}
                />
              </CBButtonWrapper>
            )}
            {description && <CBDescription className='cb_description'>
              {description}
            </CBDescription>}
            {!hideCardButtonArrow && (docWidth === window.innerWidth ? docWidth : window.innerWidth) <
              768 && (
              <CBActiveArrowWrapper className='cb_active_arrow'>
                <CBActiveArrow />
              </CBActiveArrowWrapper>
            )}
          </CBWrapper>
        </Fragment>
      )
    case 'product_card':
      return (
        <ProductCard
          id={id}
          ref={inputRef}
          type='radio'
          name={name}
          onChange={onChange}
          labelText={labelText}
          checked={checked}
          productDetails={productDetails}
        />
      )
    default:
      return (
        <Fragment>
          <Input
            id={id}
            ref={inputRef}
            type='radio'
            name={name}
            onChange={onChange}
            defaultChecked={checked}
            disabled={disabled}
            hcEnabled={hcEnabled}
          />
          <>
            <LabelText for={id} name='label-text' shape={shape}>
              {isImg(labelText) ? <Icon src={labelText} /> : labelText}
            </LabelText>
            <FakeInput name='fake-input' shape={shape} />
          </>
        </Fragment>
      )
  }
}

const HCTest = () => {
  // Create a test div
  const objDiv = document.createElement('div')

  // Set its color style to something unusual
  objDiv.style.color = 'rgb(31, 41, 59)'

  // Attach to body so we can inspect it
  document.body.appendChild(objDiv)

  // Read computed color value
  let strColor = document.defaultView
    ? document.defaultView.getComputedStyle(objDiv, null).color
    : objDiv.currentStyle.color
  strColor = strColor.replace(/ /g, '')

  // Delete the test DIV
  document.body.removeChild(objDiv)

  // Check if we get the color back that we set. If not, we're in
  // high contrast mode.
  if (strColor !== 'rgb(31,41,59)') {
    return true
  } else {
    return false
  }
}

/* eslint-disable camelcase */
const getAriaLabelText = (props) => {
  if (props.content) {
    let final_label = ''
    if (props.content.prefix) {
      final_label += props.content.prefix
    }
    if (props.content.value) {
      final_label += props.content.value
    }
    if (props.content.metric) {
      final_label += props.content.metric + ' '
    }
    if (props.content.heading) {
      final_label += props.content.heading + ' '
    }
    if (props.labelText) {
      final_label += props.labelText + ' '
    }
    if (props.content.plan_desc) {
      final_label += props.content.plan_desc + ' '
    }
    return final_label
  } else {
    return props.labelText
  }
}
/* eslint-enable camelcase */

const Radio = (props) => {
  const { shape, id } = props
  let hcEnabled = false
  hcEnabled = HCTest()
  const labelComponent = (
  <Label
    name='label'
    id={`radio-option-${shape}-${id}`}
    shape={shape}
    aria-label={getAriaLabelText(props)}
  >
    {getRadioComponent(props, hcEnabled)}
  </Label>
  )
  return (
    <>
    {
      props.displayCardHeader ? 
        <CardWithHeader>
          <CardHeading>{props.cardHeaderValue}</CardHeading>
          {labelComponent}
        </CardWithHeader>
      : 
      labelComponent
    }
    </>
  )
}

Radio.defaultProps = {
  shape: 'classic'
}

Radio.propTypes = {
  /**
   * Determines the shape and style of the radio button.
   */
  shape: PropTypes.oneOf([
    'oval',
    'rectangle',
    'classic',
    'card_columns',
    'card',
    'icon_card',
    'card_button',
    'product_card',
    'htmlRadioButton'
  ]),
  /**
   * Label of the radio button.
   */
  labelText: PropTypes.string.isRequired,
  /**
   * An id for the button.
   */
  id: PropTypes.string.isRequired,
  /**
   * Ref for Radio buttons.
   */
  inputRef: PropTypes.object,
  /**
   * A name for the buttons.
   */
  name: PropTypes.string.isRequired,
  /**
   * On change handler
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Adds border top
   */
  hasBorderTop: PropTypes.bool,
  /**
   * to handle button click in card_button shape's radio
   */
  onActionBtnClick: PropTypes.func,
  /**
   * description in card_button shape radio
   */
  description: PropTypes.string,
  /**
   * Button content to show on card for card_button shape
   */
  cardButton: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string
  }),
  /**
   * Theme to be applied to button for card_button shape
   */
  cardButtonTheme: PropTypes.object,
  /**
   * hide arrow pointer under card_button radio
   */
   hideCardButtonArrow: PropTypes.bool
}
export default Radio
